module.exports = __webpack_public_path__ + "img/04.4160dfe7.png";